module.exports = __webpack_public_path__ + "static/media/badgeImg.48da67a1.jpeg";